export class PedidoRecebimento {
  id: number;
  idCupom: string;
  data: Date;
  valor: number;
  idUsuario: number;
  nomeUsuario: string;
}
